 <template>

<router-link :title="'تعديل'" class="dropdown-item dots-options" href="javascript:void(0);" :to="routing"><i class="flaticon-edit-7"></i> تعديل</router-link>
</template>

<script>
    export default {
        components: {
        },
        props: {
            title: String,
            routing: Object,
            icon: {
            type: String,
            default: 'ti-pencil-alt'
            },
        },
        data () {
            return {
            }
        },
        computed:{
        },
        mounted() {

        },
        methods: {

		},
        watch: {

        },
    }
</script>




